var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"side-frame-success"},[_c('span',{staticStyle:{"font-size":"14px","color":"#606266"}},[_vm._v(_vm._s(_vm.$l('tips_title_sample_table') || '样品信息'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }